import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white p-4 mt-4 text-center">
      <p>© 2025 Event Planner. All rights reserved.</p>
      <p>
        Created by{" "}
        <a
          href="https://the28s.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-400 hover:text-blue-300"
        >
          the28s.com Lukas Wojciechowski
        </a>
        .
      </p>
    </footer>
  );
};

export default Footer;
